<app-detail [params]="detailParams"></app-detail>
